import Vue from 'vue'
import Router from 'vue-router'
import Web from '@/components/Web'
import Index from '@/components/Index'
import Section from '@/components/Section'
import Article from '@/components/Article'
import Search from '@/components/Search'
import Login from "@/components/Login.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      component: Web,
      children:[
        {
          path: '',
          name: 'index',
          component: Index
        },
        {
          path: '/login',
          name: 'login',
          component: Login,
          meta: {public: true}
        },
        {
          path: '/search',
          name: 'search',
          component: Search
        }, {
          path: '/:sectionId',
          name: 'section',
          component: Section
        }, {
          path: '/:sectionId/:dbid',
          name: 'article',
          component: Article
        }
      ]
    },
  ],
  scrollBehavior() {
    // return desired position
    return {x: 0, y: 0};
  }
})
